module.exports = __webpack_public_path__ + "media/images/folder-c5c07ebac5194dc63d672ea69a0dc433.svg";